let menu_items = document.querySelectorAll('.navigation.mobile a.has_submenu');
const menus = document.querySelectorAll('.navigation.mobile .menu');
menu_items.forEach(item => {
  item.addEventListener('click', e => {
    e.preventDefault(); // const parentLI = e.target.parentNode;
    // const parentUL = e.target.parentNode.parentNode;

    const parentLI = e.target.closest('li');
    const parentUL = parentLI.closest('ul'); // if(parentUL.classList.contains('mega_menu__content__wrapper')){
    //   parentUL = e.target.parentNode.parentNode.parentNode;
    // }

    menus.forEach(menu => {
      menu.classList.remove('current-menu');
    });
    parentLI.classList.add('active');
    parentUL.classList.add('active');
    const current_menu = parentLI.querySelector('.menu');
    current_menu.classList.add('current-menu');
  });
});
let back_links = document.querySelectorAll('.back_link');
back_links.forEach(item => {
  item.addEventListener('click', e => {
    e.preventDefault();
    const parentLI = e.target.parentNode.parentNode.closest('li');
    const parentUL = parentLI.parentNode.closest('ul'); // const parentLI = e.target.parentNode.parentNode.parentNode;
    // const parentUL = e.target.parentNode.parentNode.parentNode.parentNode;
    // if(parentUL.classList.contains('mega_menu__content__wrapper')){
    //   parentUL = e.target.parentNode.parentNode.parentNode.parentNode.parentNode;
    // }

    menus.forEach(menu => {
      menu.classList.remove('current-menu');
    });
    parentLI.classList.remove('active');
    parentUL.classList.remove('active');
    parentUL.classList.add('current-menu');
  });
});
const menu_toggle = document.getElementById('mobile_nav__toggle');
const mobile_menu = document.getElementById('mobile_nav');
const mobile_hamburger = document.getElementById('mobile_nav_hamburger');
const mobile_close = document.getElementById('mobile_nav_close'); // const mobile_nav_button_text = document.getElementById("mobile_nav__button_text");

menu_toggle.addEventListener('click', e => {
  if (mobile_menu.classList.contains('open')) {
    mobile_menu.classList.remove('open');
    mobile_hamburger.classList.remove('hide');
    mobile_close.classList.add('hide'); // mobile_nav_button_text.innerHTML = "MENU"
  } else {
    mobile_menu.classList.add('open');
    mobile_hamburger.classList.add('hide');
    mobile_close.classList.remove('hide'); // mobile_nav_button_text.innerHTML = "CLOSE"
  }
});
const blurTarget = document.getElementById('MainContent');
blurTarget.addEventListener('click', e => {
  if (mobile_menu.classList.contains('open')) {
    mobile_menu.classList.remove('open');
    mobile_hamburger.classList.remove('hide');
    mobile_close.classList.add('hide');
  }
});
